import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AttributeService } from "@/service/AttributeService.ts";
const initialState = {
    loading: false,
    attributes: [],
    attributeById: [],
    selectedAttribute: {}
};
const action = {
    createAttribute: createAsyncThunk('attribute/createAttribute', async (payload, thunkAPI) => {
        return (await AttributeService.create(thunkAPI, payload.data)).data;
    }),
    readAttributeByEntityId: createAsyncThunk('attribute/readAttributeByEntityId', async (payload, thunkAPI) => {
        return (await AttributeService.readAttributeById(thunkAPI, payload)).data;
    }),
    updateAttribute: createAsyncThunk("attribute/updateAttribute", async (payload, thunkAPI) => {
        return (await AttributeService.update(thunkAPI, payload.data)).data;
    }),
    bulkCreate: createAsyncThunk("attribute/bulkCreate", async (payload, thunkAPI) => {
        return (await AttributeService.bulkCreate(thunkAPI, payload.data)).data;
    }),
    delete: createAsyncThunk("attribute/delete", async (payload, thunkAPI) => {
        return (await AttributeService.delete(thunkAPI, payload.data)).data;
    }),
    read: createAsyncThunk('attribute/read', async (_, thunkAPI) => {
        try {
            const response = await AttributeService.readAttribute(thunkAPI);
            return response.data;
        }
        catch (e) {
            return thunkAPI.rejectWithValue(e.message);
        }
    }),
};
const slice = createSlice({
    name: "attribute",
    initialState,
    reducers: {
        setLoading(state, { payload }) {
            state.loading = payload;
        },
        setSelectedAttribute(state, { payload }) {
            state.selectedAttribute = payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(action.createAttribute.pending, state => {
            state.loading = true;
        }).addCase(action.createAttribute.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload);
            }
            else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.readAttributeByEntityId.pending, (state) => {
            state.loading = true;
        }).addCase(action.readAttributeByEntityId.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00") {
                state.attributeById = response.data;
            }
        }).addCase(action.updateAttribute.pending, (state) => {
            state.loading = true;
        }).addCase(action.updateAttribute.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload);
            }
            else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.delete.pending, (state) => {
            state.loading = true;
        }).addCase(action.delete.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload);
            }
            else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.bulkCreate.pending, (state) => {
            state.loading = true;
        }).addCase(action.bulkCreate.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload);
            }
            else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.read.pending, (state) => {
            state.loading = true;
        }).addCase(action.read.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00") {
                state.attributes = response.data;
            }
            // console.log(`myAttribute`, JSON.stringify(response.data))
        });
    }
});
export const attribute = {
    reducer: slice.reducer,
    action,
    mutation: slice.actions
};
